import { SignIn, SignUp, useSignIn } from "@clerk/clerk-react";
import { Box, Button, Grid, Skeleton, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";

import { AuthAction } from "features/Auth/schema";
import { trackEvent } from "utils/tracking";

interface Props {
  action: AuthAction;
  redirectUrl: string;
  signInUrl: string;
  signUpUrl: string;
  fromRoutes?: string;
  isDialog?: boolean;
}

const AuthForm = ({
  action,
  redirectUrl,
  signInUrl,
  signUpUrl,
  fromRoutes,
  isDialog = false,
}: Props) => {
  const { isLoaded } = useSignIn();

  const navigate = useNavigate();
  const appearance = {
    elements: {
      card: {
        boxShadow: "none",
        border: isDialog ? "none" : `1px solid ${grey[300]}`,
      },
    },
  };

  const handleBack = () => {
    trackEvent("Auth Form - Back Button Clicked", {
      fromRoutes: fromRoutes || "unknown",
    });
    if (fromRoutes) {
      navigate(`/${fromRoutes}`);
      return;
    }
    navigate(-1);
  };

  return (
    <Box>
      {!isDialog && (
        <>
          {" "}
          <Button
            onClick={handleBack}
            size="small"
            sx={{ color: "black", textTransform: "none", fontSize: 12 }}
          >
            <Box
              component="i"
              className="fa-regular fa-arrow-left"
              sx={{ mr: 1 }}
            />
            Back{" "}
          </Button>
          <Typography textAlign={"center"} gutterBottom>
            <Box component="span" sx={{ fontSize: { xs: 20, md: 30 } }}>
              Create a Bento Account
            </Box>
          </Typography>
          <Typography sx={{ mb: 3 }} textAlign={"center"}>
            If you already have a Bento Account, simply login{" "}
          </Typography>
        </>
      )}

      {!isLoaded && (
        <Box sx={{ p: 3 }}>
          <Skeleton animation="wave" sx={{ width: "50%", height: 50, mb: 2 }} />
          <Skeleton
            animation="wave"
            sx={{ width: "100%", height: 50, mb: 2 }}
          />

          <Skeleton
            animation="wave"
            sx={{ width: "100%", height: 500, mt: -12, mb: -10 }}
          />
        </Box>
      )}

      <Grid container justifyContent="center" alignItems={"flex-start"}>
        {isLoaded && action === AuthAction.SIGN_UP && (
          <SignUp
            appearance={appearance}
            signInUrl={signInUrl}
            afterSignUpUrl={redirectUrl}
            afterSignInUrl={redirectUrl}
          />
        )}
        {isLoaded && action === AuthAction.SIGN_IN && (
          <SignIn
            appearance={appearance}
            signUpUrl={signUpUrl}
            afterSignUpUrl={redirectUrl}
            afterSignInUrl={redirectUrl}
          />
        )}
      </Grid>
    </Box>
  );
};

export default AuthForm;
